import { createStore } from 'vuex'
import createPersistedState from 'vuex-persistedstate'

export default createStore({
  state: {
    token: '',
    accessToken:'',
    userData:[],
    isCollapse:null,
    // 题目管理模块
    topicManagementPoolTitle:'',
    topicManagementTabname:'tabA',
    topicManagementTabaFlage:false,
    topicManagementPoolId:null,

  },
  getters: {
    token: state => state.token,
    accessToken: state => state.accessToken,
    userData: state => state.userData,
    isCollapse: state => state.isCollapse,
    topicManagementPoolTitle: state => state.topicManagementPoolTitle,
    topicManagementTabname: state => state.topicManagementTabname,
    topicManagementTabaFlage: state => state.topicManagementTabaFlage,
    topicManagementPoolId: state => state.topicManagementPoolId

  },
  mutations: {
    saveToken (state, payload) {
      state.token = payload
    },
    saveAccessToken (state, payload) {
      state.accessToken = payload
    },
    saveUserData (state, payload) {
      state.userData = payload
    },
    saveIsCollapse (state, payload) {
      state.isCollapse = payload
    },
    saveTopicManagementPoolTitle (state, payload) {
      state.topicManagementPoolTitle = payload
    },
    saveTopicManagementTabname (state, payload) {
      state.topicManagementTabname = payload
    },
    saveTopicManagementTabaFlage (state, payload) {
      state.topicManagementTabaFlage = payload
    },
    saveTopicManagementPoolId (state, payload) {
      state.topicManagementPoolId = payload
    }
  },
  actions: {
    setToken ({ commit }, payload) {
      commit('saveToken', payload)
    },
    setAccessToken ({ commit }, payload) {
      commit('saveAccessToken', payload)
    },
    setUserData ({ commit }, payload) {
      commit('saveUserData', payload)
    },
    setIsCollapse ({ commit }, payload) {
      commit('saveIsCollapse', payload)
    },
    setTopicManagementPoolTitle ({ commit }, payload) {
      commit('saveTopicManagementPoolTitle', payload)
    },
    setTopicManagementTabname ({ commit }, payload) {
      commit('saveTopicManagementTabname', payload)
    },
    setTopicManagementTabaFlage ({ commit }, payload) {
      commit('saveTopicManagementTabaFlage', payload)
    },
    setTopicManagementPoolId ({ commit }, payload) {
      commit('saveTopicManagementPoolId', payload)
    }
  },
  modules: {
  },
  plugins: [createPersistedState({storage:window.sessionStorage})]
})
